var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{staticClass:"tw-uppercase tw-text-2xl tw-text-[#111]"},[_vm._v(" "+_vm._s(_vm.entityTitle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }